import { render, staticRenderFns } from "./contact-way-config.vue?vue&type=template&id=72790de3"
import script from "./contact-way-config.vue?vue&type=script&lang=ts"
export * from "./contact-way-config.vue?vue&type=script&lang=ts"
import style0 from "./contact-way-config.vue?vue&type=style&index=0&id=72790de3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports